import { gql } from 'graphql-request'

export const CHECK_TRANSACTION_STATUS = gql`
  query CheckTransactionStatus(
    $checkTransactionStatus: CheckTransactionStatusInput!
  ) {
    checkTransactionStatus(checkTransactionStatus: $checkTransactionStatus)
  }
`
